var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{class:_vm.b('attachments'),attrs:{"wrap":""}},_vm._l((_vm.attachments),function(attachment,idx){return _c('v-flex',{key:attachment.mediaPath,attrs:{"xs12":"","sm6":"","lg4":""}},[_c('attachment',{attrs:{"number":idx + 1,"attachment":attachment,"deletable":_vm.canDelete},on:{"delete":_vm.onClickDelete}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }